import { useEffect, useState } from "react";
import { range } from "lodash";
import { Autocomplete } from "@material-ui/lab";
import { Typography, makeStyles, TextField } from "@material-ui/core";
import { ReactDatePickerCustomHeaderProps } from "react-datepicker";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowCircleRightIcon from "../../../icons/components/arrow-circle-right-icon";
import ArrowCircleLeftIcon from "../../../icons/components/arrow-circle-left-icon";
import { Color } from "../../../theme/color";

type Props = ReactDatePickerCustomHeaderProps & {
  minDate: Date;
  maxDate: Date;
};

function getYearRangeOptions(minDateYear: number, maxDateYear: number) {
  return range(minDateYear, maxDateYear, 1).map((year) => year.toString());
}

export function DatePickerCustomHeader(props: Props) {
  const [years, setYears] = useState<string[]>([]);
  const [open, setOpen] = useState(false);

  const classes = useStyles({});

  const minFullYear = props.minDate.getFullYear();
  const maxFullYear = props.maxDate.getFullYear();
  const value = props.date.getFullYear().toString();

  useEffect(() => {
    setYears(getYearRangeOptions(minFullYear, maxFullYear));
  }, [minFullYear, maxFullYear]);

  return (
    <div style={{ backgroundColor: Color.White }}>
      <div className={classes.yearHeader}>
        <Autocomplete
          open={open}
          value={value}
          disablePortal
          disableClearable
          onChange={(_, newValue) => {
            props.changeYear(parseInt(newValue));
          }}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          options={years}
          classes={{
            root: classes.yearSelect,
            inputRoot: classes.yearSelectInputField,
            input: classes.yearSelectInput,
            listbox: classes.yearSelectMenu
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="standard"
              InputProps={{
                ...params.InputProps,
                readOnly: true,
                disableUnderline: true,
                endAdornment: (
                  <ArrowDropDownIcon
                    onClick={() => setOpen(true)}
                    className={classes.yearSelectIcon}
                  />
                )
              }}
            />
          )}
        />
      </div>
      <div className={classes.monthHeader}>
        <ArrowCircleLeftIcon className={classes.arrows} onClick={props.decreaseMonth} />
        <Typography variant="inherit" color="primary" className={classes.captitalize}>
          {props.date.toLocaleDateString("sv-SE", { month: "long" })}
        </Typography>
        <ArrowCircleRightIcon className={classes.arrows} onClick={props.increaseMonth} />
      </div>
    </div>
  );
}

const useStyles = makeStyles(() => ({
  yearHeader: {
    backgroundColor: `rgba(255, 134, 123, 0.15)`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "8px",
    height: "100%",
    borderRadius: "8px 8px 0 0"
  },
  yearSelect: {
    width: "90px",
    backgroundColor: "transparent",
    padding: 0,
    color: Color.PrimaryMain
  },
  yearSelectIcon: {
    position: "absolute",
    right: "8px",
    color: Color.PrimaryMain
  },
  yearSelectInput: { cursor: "pointer", padding: "0 !important" },
  yearSelectInputField: {
    cursor: "pointer !important",
    height: "auto",
    border: "none",
    fontSize: "20px",
    padding: "0 20px !important",
    color: `${Color.PrimaryMain} !important`
  },
  yearSelectMenu: {
    width: "80px",
    padding: 0,
    margin: "5px",
    maxHeight: "300px",
    overflow: "hidden",
    overflowY: "auto"
  },
  monthHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px",
    height: "100%",
    fontSize: "18px"
  },
  arrows: {
    cursor: "pointer",
    color: Color.Gray
  },
  captitalize: {
    textTransform: "capitalize"
  }
}));
